import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Button,
    Input,
    Label,
    NavLink,
    InputGroup,
    InputGroupAddon,
    Form,
} from 'reactstrap';
import { AvForm, AvGroup, AvField, AvInput } from 'availity-reactstrap-validation';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import { isUserAllowedToAccessBrand, localizeCountryNames, isUserAllowedToAddBrands } from '../../utils/CommonUtils';
import { getCroppedImg, createFileFromBase64ImageData } from '../../utils/CropImageUtils';
import {
    updateBrand,
    loadBrand,
    loadRestaurants,
    pauseRestaurant,
    uploadBannerImage,
    uploadBackgroundImage,
    clearBrand,
    deleteBackgroundImage,
    dispatchErrorMessage
} from '../../actions/index';
import {
    FRONT_END_URL,
    DEFAULT_PAGE_SIZE,
    DEFAULT_PAGING_RANGE,
    NOT_CONFIGURED,
    countryList,
    CHAIN_MANAGER,
    MENUU_MASTER_ADMIN
} from '../../utils/Constants';
import ManagerScreen from '../users/ManagerScreen';
import CommonModal from '../common/CommonModal';
import CustomThemeScreen from './CustomThemeScreen';
import AppNotificationScreen from './AppNotificationScreen';
import CustomTable from '../common/CustomTable';
import SearchButton from '../common/SearchButton';
import CropImageModal from '../common/CropImageModal';
import PromotionProviders from '../promotionProviders/PromotionProviders';
class BrandScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            brand: {
                id: -1,
                name: '',
                categories: [{
                    id: ''
                }],
                description: '',
                customerFrontEndThemeType: '',
                webSite: '',
                bannerImagePath: null,
                smallLogoFilePath: null,
                customerFrontEndTheme: null,
                googleTagManagerId: null,
                googleTagManagerIdIos: null,
                skipLocationStep: false,
                chainLevelPromotionSettings: false,
                firebaseProjectName: ''
            },
            imagePreview: null,
            brandLogoPreview: null,
            imageFormData: null,
            brandLogoFormData: null,
            manager: null,
            managerScreenOpened: false,
            managerChanged: false,
            admin: null,
            adminScreenOpened: false,
            adminChanged: false,
            stateAlreadyCopiedFromProps: false,
            advancedSearch: false,
            searchQuery: {
                id: props.match.params.id,
                country: '',
                location: '',
                manager: ''
            },
            currentPageNumber: 1,
            comingSoonOpened: false,
            customThemeOpened: false,
            themeChanged: false,
            selectedSection: 'restaurantList',
            cropBrandImageModalOpened: false,
            brandImageBase64: null,
            cropBrandLogoModalOpened: false,
            brandLogoBase64: null,
            imageExtension: null
        };

        this.changeState = this.changeState.bind(this);
        this.changeSearchBarState = this.changeSearchBarState.bind(this);
        this.assignManager = this.assignManager.bind(this);
        this.assignAdmin = this.assignAdmin.bind(this);
        this.toggleModals = this.toggleModals.bind(this);
        this.handleSubmitTheme = this.handleSubmitTheme.bind(this);
    }

    componentDidMount() {
        this.props.loadBrand(this.props.match.params.id);
        this.props.loadRestaurants(1, this.state.searchQuery);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.brand !== this.props.brand) {
            this.setState({
                ...this.state,
                brand: {
                    ...this.props.brand,
                    customerFrontEndThemeType: this.props.brand.customerFrontEndTheme.type
                },
                manager: this.props.brand.manager
            });
        }

        if (prevProps.brand.customerFrontEndTheme !== this.props.brand.customerFrontEndTheme) {
            this.setState({
                ...this.state, brand: { ...this.state.brand, customerFrontEndTheme: this.props.brand.customerFrontEndTheme }
            })
        }
    }

    copyStateFromProps() {
        const { brand } = this.props;

        if (brand != null && brand.id !== undefined && brand.id !== -1 &&
            (!this.state.stateAlreadyCopiedFromProps || brand.id !== this.state.brand.id)) {

            this.setState({
                brand: {
                    id: brand.id,
                    name: brand.name,
                    categories: brand.categories,
                    description: brand.description,
                    customerFrontEndThemeType: brand.customerFrontEndTheme.type,
                    webSite: brand.webSite,
                    bannerImagePath: brand.bannerImagePath,
                    smallLogoFilePath: brand.smallLogoFilePath,
                    customerFrontEndTheme: brand.customerFrontEndTheme,
                    googleTagManagerId: brand.googleTagManagerId,
                    googleTagManagerIdIos: brand.googleTagManagerIdIos,
                    skipLocationStep: brand.skipLocationStep,
                    chainLevelPromotionSettings: brand.chainLevelPromotionSettings,
                    firebaseProjectName: brand.firebaseProjectName
                },
                manager: brand.manager,
                admin: brand.admin,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    changeState({ target }) {
        let targetValue = target.value;
        if (target.name === 'skipLocationStep') {
            targetValue = target.checked;
        }
        this.setState({
            brand: {
                ...this.state.brand,
                [target.name]: targetValue,

            },
            // Check if custom theme has colors in it, if NOT open modal
            customThemeOpened: target.value === 'CUSTOM' ? (this.state.brand.customerFrontEndTheme.primaryColor === null ? true : false) : false,
            themeChanged: target.name === 'customerFrontEndThemeType' ? true : false
        });
    }

    changeSearchBarState({ target }) {
        this.setState({
            searchQuery: {
                ...this.state.searchQuery,
                [target.name]: target.value
            }
        });
    }

    updateBrand() {
        if (typeof (this.state.brand.customerFrontEndTheme.backGroundImageFilePath) === 'string' || !this.state.brand.customerFrontEndTheme.backGroundImageFilePath) {
            this.props.updateBrand(this.state);
        } else {
            this.props.uploadBackgroundImage(this.state);
        }
        this.setState({
            managerChanged: false,
            adminChanged: false,
            themeChanged: false
        });
    }

    toggleSearch() {
        // toggling the search should reset the search query
        this.setState({
            advancedSearch: !this.state.advancedSearch,
            searchQuery: {
                id: this.props.match.params.id,
                country: '',
                location: '',
                manager: ''
            },
            currentPageNumber: 1
        });
        this.props.loadRestaurants(1, this.state.searchQuery);
    }

    search() {
        //new search should always start from page 1
        this.props.loadRestaurants(1, this.state.searchQuery);

        this.setState({
            currentPageNumber: 1
        });
    }

    clearSearch() {
        //new search should always start from page 1
        this.setState({
            searchQuery: {
                id: this.props.match.params.id,
                country: '',
                location: '',
                manager: ''
            },
            currentPageNumber: 1
        });
        this.props.loadRestaurants(1, this.state.searchQuery);
    }

    toggleModals(modalName) {
        this.setState({
            [`${modalName}Opened`]: !this.state[`${modalName}Opened`]
        });
    }

    pause(event) {
        var restaurantPauseStatus = event.target.checked;
        var restaurantId = event.target.id;

        this.props.pauseRestaurant(restaurantPauseStatus, restaurantId, this.state.currentPageNumber, this.state.searchQuery);
    }

    keyPress(event) {
        if (event.keyCode === 13) { // this is Enter
            this.search();
        }
    }

    handlePageChange(pageNumber) {
        this.setState({
            currentPageNumber: pageNumber
        });
        this.props.loadRestaurants(pageNumber, this.state.searchQuery);
    }

    assignManager(selectedManager) {
        this.setState({
            managerScreenOpened: !this.state.managerScreenOpened,
            manager: selectedManager,
            managerChanged: true
        });
    }

    assignAdmin(selectedAdmin) {
        this.setState({
            adminScreenOpened: !this.state.adminScreenOpened,
            admin: selectedAdmin,
            adminChanged: true
        });
    }

    renderBrandName() {
        const { labelStyler, alignInRow, brandFields } = styles;
        const { name } = this.state.brand;

        return (
            <AvGroup style={alignInRow}>
                <Label for="name" style={labelStyler} sm={3}>{i18n.t('common:form.name')}:</Label>
                <Col sm={9} style={brandFields}>
                    <AvField type="name" name="name" id="name"
                        value={name}
                        onChange={this.changeState}
                        required
                        errorMessage={i18n.t('common:validations.errorMsg')} />
                </Col>
            </AvGroup>
        );
    }

    renderBrandCategory() {
        const { labelStyler, alignInRow } = styles;
        const { categories } = this.state.brand;

        return (
            <AvGroup style={alignInRow}>
                <Label for="categories" style={labelStyler} sm={3}>{i18n.t('screens:menuConfigScreen.category')}:</Label>
                <Col sm={9}>
                    <AvField type="select" name="categories" id="categories"
                        value={categories}
                        onChange={this.changeState}
                    >
                        <option value="1">{i18n.t('screens:brandScreen.categoryPizza')}</option>
                        {/* <option value="100">Pizza</option> */}
                    </AvField>
                </Col>
            </AvGroup>
        );
    }

    renderBrandWebsite() {
        const { labelStyler, alignInRow, brandFields } = styles;
        const { webSite } = this.state.brand;

        return (
            <AvGroup style={alignInRow}>
                <Label for="webSite" style={labelStyler} sm={3}>{i18n.t('screens:brandScreen.website')}:</Label>
                <Col sm={9} style={brandFields}>
                    <AvField type="text" name="webSite" id="website"
                        value={webSite ? webSite : ''}
                        placeholder="http://example.com"
                        onChange={this.changeState} />
                </Col>
            </AvGroup>
        );
    }

    renderAnalyticsId() { // TODO - to be deleted!!
        const { googleTagManagerId } = this.state.brand;

        return (
            <AvGroup style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Label for='googleTagManagerId' style={{ padding: '0 0 0 15px', display: 'flex', alignItems: 'center' }} >Google Tag Manager ID:</Label>
                <Col style={{ padding: '0 15px 0 0', marginLeft: 10 }}>
                    <AvInput style={{ marginBottom: 0 }}
                        type='text' name='googleTagManagerId' id='googleTagManagerId'
                        value={googleTagManagerId}
                        onChange={this.changeState}
                    />
                </Col>
            </AvGroup>
        );
    }

    renderSkipLocation() {

        return (
            <AvGroup style={{ width: '100%', display: 'flex', flexDirection: 'row', marginTop: 12 }}>
                <Label for='skipLocationStep' style={{ paddingLeft: 15 }}>{i18n.t('screens:brandScreen.skipCollection')}</Label>
                <AvInput type="checkbox" name='skipLocationStep'
                    style={{ display: 'flex', position: 'relative', margin: '0.4rem 10px 0 10px' }}
                    checked={this.state.brand.skipLocationStep}
                    onChange={this.changeState}
                />
            </AvGroup>
        );
    }

    renderIosAnalytics() {// TODO - to be deleted!!
        const { googleTagManagerIdIos } = this.state.brand;

        return (
            <AvGroup style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Label for='googleTagManagerIdIos' style={{ padding: '0 0 0 15px', display: 'flex', alignItems: 'center' }} >IOS Google Tag Manager ID:</Label>
                <Col style={{ padding: '0 15px 0 0', marginLeft: 10 }}>
                    <AvInput style={{ marginBottom: 0 }}
                        type='text' name='googleTagManagerIdIos' id='googleTagManagerIdIos'
                        value={googleTagManagerIdIos}
                        onChange={this.changeState}
                    />
                </Col>
            </AvGroup>
        );
    }

    renderFirebaseProjectId() {

        const { currentlyLoggedInUser } = this.props;
        const userAllowedToAccessBrand = this.props.currentlyLoggedInUser.id !== -1 && isUserAllowedToAddBrands(currentlyLoggedInUser);
       
        if (!userAllowedToAccessBrand) {
            return null;
        }

        const { firebaseProjectName } = this.state.brand;

        return (
            <AvGroup style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Label for='firebaseProjectName' style={{ padding: '0 0 0 15px', display: 'flex', alignItems: 'center' }} >{i18n.t('common:form.firebaseProjectId')}:</Label>
                <Col style={{ padding: '0 15px 0 0', marginLeft: 10 }}>
                    <AvInput style={{ marginBottom: 0 }}
                        type='text' name='firebaseProjectName' id='firebaseProjectName'
                        value={firebaseProjectName}
                        onChange={this.changeState}
                    />
                </Col>
            </AvGroup>
        );
    }

    renderBrandDescription() {
        const { labelStyler, textArea, alignInRow, brandFields } = styles;
        const { description } = this.state.brand;

        return (
            <AvGroup style={alignInRow}>
                <Label for="description" style={labelStyler} sm={3}>{i18n.t('common:form.description')}:</Label>
                <Col sm={9} style={brandFields}>
                    <AvField type="textarea" name="description" id="description" style={textArea}
                        value={description}
                        onChange={this.changeState}
                        required
                        errorMessage={i18n.t('common:validations.errorMsg')} />
                </Col>
            </AvGroup>
        )
    }

    renderBrandTheme() {
        const { labelStyler, alignInRow, saveWarning } = styles;
        const { customerFrontEndThemeType } = this.state.brand;

        const themeDark = 'DARK', themeLight = 'LIGHT', themeCustom = 'CUSTOM';
        let selectedTheme = customerFrontEndThemeType === themeCustom ? 8 : 9;
        let isHidden = customerFrontEndThemeType !== themeCustom ? true : false;
        const saveWarningMessage = this.state.themeChanged ? `${i18n.t('common:validations.saveWarningMsg')}` : '';

        return (
            <React.Fragment>
                <AvGroup style={alignInRow}>
                    <Label for="customerFrontEndThemeType" style={labelStyler} sm={3}>{i18n.t('screens:brandScreen.theme')}:</Label>
                    <Col sm={selectedTheme}>
                        <AvField type="select" name="customerFrontEndThemeType" id="customerFrontEndThemeType"
                            value={customerFrontEndThemeType}
                            onChange={this.changeState}
                        >
                            <option value={themeLight}>{i18n.t('screens:brandScreen.themeLight')}</option>
                            <option value={themeDark}>{i18n.t('screens:brandScreen.themeDark')}</option>
                            <option value={themeCustom}>{i18n.t('screens:brandScreen.themeCustom')}</option>
                        </AvField>
                    </Col>
                    <Button hidden={isHidden} sm={1} color="link" onClick={() => this.toggleModals('customTheme')} style={{ paddingLeft: 0 }}>{i18n.t('screens:brandScreen.edit')}</Button>
                </AvGroup>
                <p>
                    <span id="saveWarning" style={saveWarning}>{saveWarningMessage}</span>
                </p>
            </React.Fragment>
        );
    }

    renderBrandLogo() {
        const { imageColumn, figureLogo, alignInRow, brandLogoLabel, specificationsContainer, specificationsText } = styles;
        const { brand, brandLogoPreview } = this.state;
        let imageSrc;
        let labelStyle;
        let imgStyle;

        if (brandLogoPreview !== null) {
            imageSrc = brandLogoPreview;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 };
        } else if (brand.smallLogoFilePath === null) {
            imageSrc = brandLogoPreview;
            labelStyle = 'coloured-label'
            imgStyle = { height: '100%', objectFit: 'cover', zIndex: 1 };
        } else {
            imageSrc = `${FRONT_END_URL}/${brand.smallLogoFilePath}`;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }
        }

        return (
            <Col sm={12} md={12} style={Object.assign({}, imageColumn, alignInRow)}>
                <Label sm={3} style={{ padding: '10px 0px 0px 12px' }}> {i18n.t('screens:brandScreen.brandLogo')}:</Label>
                <Col sm={9}>
                    {/* <SliderPicker /> */}
                    <figure style={figureLogo}>
                        <input id="brandLogoPreview" value={''} className="custom-file-input" type="file" name="brandLogoPreview" onChange={(event) => this.uploadBrandLogo(event)} />
                        <label className={labelStyle} style={brandLogoLabel} for="brandLogoPreview">
                            <div style={specificationsContainer}>
                                <span><MaterialIcon icon="local_see" size={30} /></span>
                                {i18n.t('common:buttons.fileUpload')}
                                <div style={specificationsText}>{i18n.t('screens:brandScreen.specificationsLogo')}</div>
                            </div>
                        </label>
                        <img style={imgStyle} src={imageSrc} />
                    </figure>
                </Col>
            </Col>
        );
    }

    renderBrandManager() {
        const { labelStyler, alignInRow, noPadding } = styles;

        let managerMarkup;
        if (this.state.manager == null) {
            managerMarkup = this.renderAssignBrandManager();
        } else {
            managerMarkup = this.renderChangeBrandManager();
        }

        return (
            <AvGroup style={{ ...alignInRow, marginBottom: 0 }}>
                <Label for="brandManager" style={labelStyler}>{i18n.t('screens:brandScreen.brandManager')}:</Label>
                <Col style={noPadding}>
                    {managerMarkup}
                </Col>
            </AvGroup>
        );
    }

    renderBrandAdmin() {
        const { labelStyler, alignInRow, noPadding } = styles;

        let brandAdminMarkup;
        if (this.state.admin == null) {
            brandAdminMarkup = this.renderAssignBrandAdmin();
        } else {
            brandAdminMarkup = this.renderChangeBrandAdmin();
        }

        return (
            <AvGroup style={{ ...alignInRow, marginBottom: 0 }}>
                <Label for="brandAdmin" style={labelStyler}>{i18n.t('screens:brandScreen.brandAdmin')}:</Label>
                <Col style={noPadding}>
                    {brandAdminMarkup}
                </Col>
            </AvGroup>
        );
    }

    renderForm() {
        const { logoBox, logoboxLabel, saveButton, spaceBetween, alignInRow, alignInColumn, brandInfoContainer, noPadding } = styles;
        const { imagePreview } = this.state;
        const { bannerImagePath } = this.state.brand;

        const imageHeader = {
            noImage: i18n.t('screens:brandScreen.noImg'),
            changeImage: i18n.t('screens:brandScreen.changeImg')
        };

        return (
            <Col>
                <AvForm onValidSubmit={this.updateBrand.bind(this)}>
                    <Col md={12} style={Object.assign({}, alignInRow, brandInfoContainer, noPadding)}>
                        <Col md={4} style={Object.assign({}, alignInColumn, noPadding)}>
                            <Col md={12} style={logoBox}>
                                <Label style={logoboxLabel}>{imagePreview === null && bannerImagePath === null ? imageHeader.noImage : imageHeader.changeImage}:</Label>
                                {this.renderBrandImages()}
                            </Col>
                        </Col>
                        <Col md={8} style={Object.assign({ paddingTop: 30 }, alignInColumn)}>
                            <Col md={12} style={Object.assign({ flexWrap: 'wrap' }, alignInRow)}>
                                <Col md={6} style={noPadding}>
                                    {this.renderBrandName()}
                                    {this.renderBrandDescription()}
                                    {this.renderBrandWebsite()}
                                    {/* {this.renderAnalyticsId()}          // TODO - to be deleted!! */}
                                    {this.renderSkipLocation()}

                                </Col>
                                <Col md={6} style={noPadding}>
                                    {this.renderBrandCategory()}
                                    {this.renderBrandLogo()}
                                    {this.renderBrandTheme()}
                                    {/*this.renderIosAnalytics()*/}
                                    { this.props.currentlyLoggedInUser.role === MENUU_MASTER_ADMIN ?
                                        this.renderFirebaseProjectId() : null
                                    }
                                </Col>
                                <Col md={12} hidden={this.props.currentlyLoggedInUser.role === CHAIN_MANAGER}>
                                    {this.renderBrandAdmin()}
                                </Col>
                                <Col md={12}>
                                    {this.renderBrandManager()}
                                </Col>
                                <Col md={12}>
                                    <Button color="primary" sm={12} style={saveButton}>
                                        <MaterialIcon icon="save" color="#fff" size={18} /><span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
                                    </Button>
                                </Col>
                            </Col>
                        </Col>
                    </Col>
                </AvForm>
                {
                    this.state.managerScreenOpened ?
                        <ManagerScreen
                            title={i18n.t('screens:brandScreen.brandManager')}
                            role='CHAIN_MANAGER'
                            isOpen={this.state.managerScreenOpened}
                            onToggle={this.toggleModals}
                            onAssign={this.assignManager} /> : null
                }
                {
                    this.state.adminScreenOpened ?
                        <ManagerScreen
                            title={i18n.t('screens:brandScreen.brandAdmin')}
                            role='CHAIN_ADMIN'
                            isOpen={this.state.adminScreenOpened}
                            onToggle={this.toggleModals}
                            onAssign={this.assignAdmin} /> : null
                }
            </Col>
        );
    }

    renderBrandImages() {
        const { imageColumn, figure, brandBanner, brandBannerLabel, brandBannerSpecifications } = styles;
        const { brand, imagePreview } = this.state;
        let imageSrc;
        let labelStyle;
        let imgStyle;

        if (imagePreview !== null) {
            imageSrc = imagePreview;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 };
        } else if (brand.bannerImagePath === null) {
            imageSrc = imagePreview;
            labelStyle = 'coloured-label'
            imgStyle = { height: '100%', objectFit: 'cover', zIndex: 1 };
        } else {
            imageSrc = `${FRONT_END_URL}/${brand.bannerImagePath}`;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }
        }

        return (
            <Col style={imageColumn}>
                <figure style={figure}>
                    <input id="imagePreview" value={''} className="custom-file-input" type="file" name="imagePreview" onChange={(event) => this.uploadImage(event)} />
                    <label className={labelStyle} style={brandBannerLabel} for="imagePreview">
                        <div style={brandBanner}>
                            <span><MaterialIcon icon="local_see" size={30} /></span>
                            {i18n.t('common:buttons.fileUpload')}
                            <div style={brandBannerSpecifications}>{i18n.t('screens:brandScreen.specifications')}</div>
                        </div>
                    </label>
                    <img style={imgStyle} src={imageSrc} />
                </figure>
            </Col>
        );
    }

    uploadImage(event) {
        event.preventDefault();
        const file = event.target.files[0];

        if (file.size > 2000000) {
            this.props.dispatchErrorMessage(`${i18n.t('common:validations.maximumImageSize')} 2MB`)
        } else {
            if (file !== undefined) {                           // file === undefined when you click cancel
                this.setState({
                    ...this.state,
                    imagePreview: URL.createObjectURL(file),
                    imageFormData: event.target.files[0]
                });

                //this is for crop image
                let reader = new FileReader();

                reader.onloadend = () => {
                    this.setState({
                        ...this.state,
                        brandImageBase64: reader.result,
                        imageExtension: file.type
                    }, () => this.toggleBrandImageCropModal());
                };
                reader.readAsDataURL(file);
            }
        }
    }

    uploadBrandLogo(event) {
        event.preventDefault();
        const file = event.target.files[0];

        if (file.size > 1000000) {
            this.props.dispatchErrorMessage(`${i18n.t('common:validations.maximumImageSize')} 1MB`)
        } else {
            if (file !== undefined) {                           // file === undefined when you click cancel
                this.setState({
                    ...this.state,
                    brandLogoPreview: URL.createObjectURL(file),
                    brandLogoFormData: event.target.files[0]
                });

                //this is for crop image
                let reader = new FileReader();

                reader.onloadend = () => {
                    this.setState({
                        ...this.state,
                        brandLogoBase64: reader.result,
                        imageExtension: file.type
                    }, () => this.toggleBrandLogoCropModal());
                };
                reader.readAsDataURL(file);
            }
        }
    }

    renderAssignBrandManager() {
        const { assignManagerBtn } = styles;

        return (
            <Button color="link" onClick={() => this.toggleModals('managerScreen')} style={assignManagerBtn}>{i18n.t('common:buttons.assignManager')}</Button>
        )
    }

    renderChangeBrandManager() {
        const { managerFieldGroups, managerDetails, noBottomMargin, saveWarning } = styles;
        const saveWarningMessage = this.state.managerChanged ? `${i18n.t('common:validations.saveWarningMsg')}` : '';

        return (
            <div style={managerFieldGroups}>
                <p style={noBottomMargin}>
                    <span style={managerDetails}>
                        &nbsp; &nbsp;{this.state.manager.name} &nbsp;
                        &nbsp;|&nbsp; {this.state.manager.phone} &nbsp;
                        &nbsp;|&nbsp; {this.state.manager.email} &nbsp;|&nbsp;
                    </span>
                    <Button style={{paddingBottom: '7px'}} color="link" onClick={() => this.toggleModals('managerScreen')}>{i18n.t('common:buttons.changeManager')} </Button>
                </p>
                <p>
                    <span id="saveWarning" style={saveWarning}>{saveWarningMessage}</span>
                </p>
            </div>
        );
    }

    renderAssignBrandAdmin() {
        const { assignManagerBtn } = styles;

        return (
            <Button color="link" onClick={() => this.toggleModals('adminScreen')} style={assignManagerBtn}>{i18n.t('common:buttons.assignAdmin')}</Button>
        )
    }

    renderChangeBrandAdmin() {
        const { managerFieldGroups, managerDetails, noBottomMargin, saveWarning } = styles;
        const saveWarningMessage = this.state.adminChanged ? `${i18n.t('common:validations.saveWarningMsg')}` : '';

        return (
            <div style={managerFieldGroups}>
                <p style={noBottomMargin}>
                    <span style={managerDetails}>
                        &nbsp; &nbsp;{this.state.admin.name} &nbsp;
                        &nbsp;|&nbsp; {this.state.admin.phone} &nbsp;
                        &nbsp;|&nbsp; {this.state.admin.email} &nbsp;|&nbsp;
                    </span>
                    <Button style={{paddingBottom: '7px'}} color="link" onClick={() => this.toggleModals('adminScreen')}>{i18n.t('common:buttons.changeAdmin')} </Button>
                </p>
                <p>
                    <span id="saveWarning" style={saveWarning}>{saveWarningMessage}</span>
                </p>
            </div>
        );
    }

    renderSimpleSearch() {
        const { inputGroupSearch, inputSearch, simpleSearchPipe, inputGroupAddon, cursorPointer, flexEnd } = styles;
        const { location } = this.state.searchQuery;

        return (
            <Col>
                <Row>
                    <Col xs="auto" sm={10} >
                        <Row>
                            <Col xs={4}>
                                <InputGroup style={inputGroupSearch}>
                                    <Input
                                        type="text" name="location" id="location" placeholder={i18n.t('screens:restaurantsScreen.location')}
                                        value={location}
                                        onChange={this.changeSearchBarState}
                                        onKeyDown={this.keyPress.bind(this)} style={inputSearch} />
                                    <InputGroupAddon addonType="append" style={inputGroupAddon}>
                                        <div onClick={this.search.bind(this)} style={cursorPointer}>
                                            <MaterialIcon icon="search" color="#0288D1" size={28} />
                                        </div>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={10}>
                        <Row>
                            <Col xs={4} style={flexEnd}>
                                <Button color="link" onClick={this.clearSearch.bind(this)}>{i18n.t('common:searchForms.clear')}</Button>
                                <span style={simpleSearchPipe}>|</span>
                                <Button color="link" onClick={this.toggleSearch.bind(this)}>{i18n.t('common:searchForms.advancedSearch')}</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        );
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    renderAdvancedSearch() {
        const { advancedSearchClearStyle, advancedSearchIcon, paddingLeftRight, paddingRight,
            advancedSearchPipe, simpleSearchButton, searchButtonStyle, advancedSearchMainCol } = styles;
        const { country, location, manager } = this.state.searchQuery;

        return (
            <Col>
                <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                    <Row>
                        <Col xs="auto" sm={8} md={8} style={advancedSearchMainCol}>
                            <Row>
                                <Col style={paddingRight}>
                                    <Input
                                        type="select" name="country" id="country" placeholder={i18n.t('screens:restaurantsScreen.country')}
                                        value={country}
                                        onChange={this.changeSearchBarState}
                                    >
                                        <option value="">{i18n.t('common:validations.chooseCountry')}</option>
                                        {this.renderCountryOptions()}
                                    </Input>
                                </Col>
                                <Col style={paddingLeftRight}>
                                    <Input
                                        type="text" name="location" id="location" placeholder={i18n.t('screens:restaurantsScreen.location')}
                                        value={location}
                                        onChange={this.changeSearchBarState} />
                                </Col>
                                <Col style={paddingLeftRight}>
                                    <Input
                                        type="text" name="manager" id="manager" placeholder={i18n.t('screens:brandScreen.manager')}
                                        value={manager}
                                        onChange={this.changeSearchBarState} />
                                </Col>
                                <Col>
                                    <SearchButton search={this.search.bind(this)} />
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button color="link" onClick={this.clearSearch.bind(this)}>{i18n.t('common:searchForms.clear')}</Button>
                                        <span style={advancedSearchPipe}>|</span>
                                        <Button color="link" style={simpleSearchButton} onClick={this.toggleSearch.bind(this)}>{i18n.t('common:searchForms.simpleSearch')}</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </Col>
        );
    }

    renderCountryOptions() {
        return countryList.map((country, i) => {
            return <option key={i} value={country}>{localizeCountryNames(country)}</option>
        });
    }

    renderRestaurantsTableRows() {
        const { restaurants } = this.props;
        const { inputCheckbox, locationColor, tableThStyle } = styles

        if (restaurants.content !== undefined && restaurants.content !== null) {
            return this.props.restaurants.content.map(restaurant => {

                const posStatusPaused = restaurant.posPaused;
                const disablePosStatusPaused = (restaurant.posStatus === NOT_CONFIGURED) ? true : false;

                let key = { 'key': restaurant.restaurantId };

                return (
                    <tr {...key} className="d-flex">
                        <td className="col-2" style={tableThStyle}>{restaurant.restaurantName}</td>
                        <td className="col-1" style={tableThStyle}>{restaurant.country}</td>
                        <td className="col-2" style={tableThStyle}>
                            <NavLink id={restaurant.restaurantId}
                                tag={Link}
                                to={`/restaurant/${restaurant.restaurantId}/settings/general`}
                                style={locationColor}
                            >{restaurant.location}</NavLink>
                        </td>
                        <td className="col-1" style={tableThStyle}>{restaurant.phone}</td>
                        <td className="col-2" style={tableThStyle}>{restaurant.email}</td>
                        <td className="col-1" style={tableThStyle}>{restaurant.managerName}</td>
                        <td className="col-2" style={tableThStyle}>{restaurant.userLastActiveTime}</td>
                        <td className="col-1" style={tableThStyle}>
                            <Input type="checkbox" style={inputCheckbox} id={restaurant.restaurantId}
                                name={restaurant.restaurantId} checked={posStatusPaused} disabled={disablePosStatusPaused}
                                onChange={this.pause.bind(this)} />
                        </td>
                    </tr>
                );
            });
        } else {
            return <div></div>;
        }
    }

    renderPagination() {
        return (
            <Pagination
                activePage={this.props.restaurants.number + 1}
                itemsCountPerPage={DEFAULT_PAGE_SIZE}
                totalItemsCount={this.props.restaurants.totalElements}
                pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                itemClass='page-item'
                linkClass='page-link'
                onChange={this.handlePageChange.bind(this)}
            />
        );
    }

    handleSubmitTheme(customColors) {
        this.setState({
            brand: {
                ...this.state.brand,
                customerFrontEndTheme: customColors
            },
            themeChanged: true
        });
    }

    changeSection = (section) => {
        this.setState({
            ...this.state,
            selectedSection: section
        });
    };

    toggleBrandImageCropModal = () => {
        this.setState({
            ...this.state,
            cropBrandImageModalOpened: !this.state.cropBrandImageModalOpened
        });
    }

    onCropBrandImageUpload = async (crop) => {
        try {
            const imageData = await getCroppedImg(crop.image, crop.croppedAreaPixels, 0, this.state.imageExtension);
            const blobData = createFileFromBase64ImageData(imageData, this.state.imageExtension);
            const uploadImageExtension = this.state.imageExtension.split('/')[1];
            const imageFile = new File([blobData], `brandImage.${uploadImageExtension}`, { type: blobData.type });

            this.setState({
                ...this.state,
                imagePreview: imageData,
                imageFormData: imageFile
            }, () => this.toggleBrandImageCropModal());
        } catch (e) {
            console.error(e);
        }
    }

    toggleBrandLogoCropModal = () => {
        this.setState({
            ...this.state,
            cropBrandLogoModalOpened: !this.state.cropBrandLogoModalOpened
        });
    }

    onCropBrandLogoUpload = async (crop) => {
        try {
            const imageData = await getCroppedImg(crop.image, crop.croppedAreaPixels, 0, this.state.imageExtension);
            const blobData = createFileFromBase64ImageData(imageData, this.state.imageExtension);
            const uploadImageExtension = this.state.imageExtension.split('/')[1];
            const imageFile = new File([blobData], `brandLogo.${uploadImageExtension}`, { type: blobData.type });

            this.setState({
                ...this.state,
                brandLogoPreview: imageData,
                brandLogoFormData: imageFile
            }, () => this.toggleBrandLogoCropModal());
        } catch (e) {
            console.error(e);
        }
    }

    renderSections() {
        switch (this.state.selectedSection) {
            case 'restaurantList':
                return this.renderBrandRestaurants();
            case 'appNotifications':
                return <AppNotificationScreen
                    brandId={this.props.match.params.id}
                />;
            case 'promotionProviders':
                return <PromotionProviders isBrandScreen={true}/>;
            default:
                return null;
        }
    }

    renderBrandRestaurants() {
        const { rowStyler, alignRight } = styles;

        return (
            <React.Fragment>
                <Row style={rowStyler}>
                    {!this.state.advancedSearch ? this.renderAdvancedSearch() : this.renderSimpleSearch()}
                    <Col sm={2} style={alignRight}>
                        <Button color="primary" onClick={() => this.toggleModals('comingSoon')} style={{ marginTop: 8 }} >
                            <span style={{ marginLeft: 4 }}><MaterialIcon icon="list_alt" color="#fff" size={19} /> </span>
                            {i18n.t('screens:brandScreen.enterpriseMenus')}
                        </Button>
                        <NavLink id={-1}
                            tag={Link}
                            to={`/restaurant/${-1}/settings/general`}
                        >
                            <Button color="primary">
                                <MaterialIcon icon="add_circle_outline" color="#fff" size={20} />
                    &nbsp;{i18n.t('screens:brandScreen.addRestaurant')}
                            </Button>
                        </NavLink>

                    </Col>
                </Row>
                <Row style={rowStyler}>
                    <Col>
                        {
                            this.props.restaurants.content !== undefined ?
                                <CustomTable
                                    styles={styles}
                                    tableName='brandRestaurantsTable'
                                    tableData={this.props.restaurants.content}
                                    currentUser={this.props.currentlyLoggedInUser}
                                    handlePause={this.pause.bind(this)}
                                />
                                :
                                <Row></Row>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col style={alignRight}>
                        {this.renderPagination()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    render() {
        const { containerStyle, restaurantsHeading, sections, active } = styles;
        const { brand, currentlyLoggedInUser } = this.props;
        const userAllowedToAccessBrand = this.props.currentlyLoggedInUser.id !== -1 && isUserAllowedToAccessBrand(brand, currentlyLoggedInUser);

        if (userAllowedToAccessBrand) {
            this.copyStateFromProps();

            return (
                <Container fluid style={containerStyle}>
                    <Row>
                        {this.renderForm()}
                    </Row>
                    <Row>
                        <Col>
                            <div style={restaurantsHeading}>
                                <div onClick={() => this.changeSection("restaurantList")} style={this.state.selectedSection === 'restaurantList' ? { ...active, ...sections } : sections}>
                                    <MaterialIcon icon="list" color="inherit"
                                        size={32} />{i18n.t('screens:restaurantsMainContainer.restaurants')}
                                </div>
                                <div onClick={() => this.changeSection("appNotifications")} style={this.state.selectedSection === 'appNotifications' ? { ...active, ...sections } : sections}>
                                    <MaterialIcon icon="message" color="inherit"
                                        size={32} />{i18n.t('screens:restaurantsMainContainer.appNotifications')}
                                </div>
                                <div
                                    onClick={() => this.changeSection('promotionProviders')}
                                    style={this.state.selectedSection === 'promotionProviders' ? { ...active, ...sections, display: 'flex' } : { ...sections, display: 'flex' }}>
                                    <div style={{ width: 32 }}>
                                        <MaterialIcon icon="styles" size={32} color='inherit' />
                                    </div>
                                    <div style={{ marginTop: 2 }}>
                                        {i18n.t('screens:brandScreen.promotionProviders')}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {this.renderSections()}
                    {
                        this.state.comingSoonOpened &&
                        <CommonModal
                            useCase={'comingSoon'}
                            isOpen={this.state.comingSoonOpened}
                            onToggle={this.toggleModals}
                        >
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <h4>{i18n.t('common:temporary.comingSoon')}</h4>
                            </div>
                        </CommonModal>
                    }

                    {
                        this.state.brand.customerFrontEndThemeType === 'CUSTOM' && this.state.customThemeOpened ?
                            <CustomThemeScreen
                                isOpen={this.state.customThemeOpened}
                                onToggle={this.toggleModals}
                                handleSubmit={this.handleSubmitTheme}
                                themeColors={this.state.brand.customerFrontEndTheme}
                                deleteBackgroundImage={this.props.deleteBackgroundImage}
                                styles={styles} /> : null
                    }
                    {
                        this.state.cropBrandImageModalOpened ?
                            <CropImageModal
                                isOpen={this.state.cropBrandImageModalOpened}
                                onClickSave={this.onCropBrandImageUpload}
                                toggle={this.toggleBrandImageCropModal}
                                modalClass='cropBrandImage'
                                crop={{
                                    image: this.state.brandImageBase64,
                                    crop: { x: 0, y: 0 },
                                    zoom: 1,
                                    cropSize: { width: 1000, height: 600 },
                                    croppedAreaPixels: null,
                                }}
                            /> : null
                    }
                    {
                        this.state.cropBrandLogoModalOpened ?
                            <CropImageModal
                                isOpen={this.state.cropBrandLogoModalOpened}
                                onClickSave={this.onCropBrandLogoUpload}
                                toggle={this.toggleBrandLogoCropModal}
                                modalClass='cropBrandLogo'
                                crop={{
                                    image: this.state.brandLogoBase64,
                                    crop: { x: 0, y: 0 },
                                    zoom: 1,
                                    cropSize: { width: 512, height: 512 },
                                    croppedAreaPixels: null,
                                }}
                            /> : null
                    }
                </Container>
            );
        } else {
            return (
                <Container>
                </Container>
            );
        }
    }
}

const mapStateToProps = state => {
    return {
        currentlyLoggedInUser: state.user,
        brand: state.brand,
        restaurant: state.restaurant,
        restaurants: state.restaurants
    }
}

export default connect(
    mapStateToProps,
    {
        updateBrand,
        loadBrand,
        loadRestaurants,
        pauseRestaurant,
        uploadBannerImage,
        clearBrand,
        uploadBackgroundImage,
        deleteBackgroundImage,
        dispatchErrorMessage
    }
)(BrandScreen);

let styles = {
    containerStyle: {
        width: '96%',
        marginTop: 20,
        paddingLeft: 0,
        paddingRight: 0
    },
    brandInfoContainer: {
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
    },
    logoBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingRight: 0,
        flexDirection: 'column',
        textAlign: 'left',
        height: 300,
        paddingBottom: 40
    },
    logoboxLabel: {
        fontWeight: 500,
        alignSelf: 'flex-start'
    },
    imageColumn: {
        justifyContent: 'center',
        flexGrow: 1,
        padding: 0
    },
    figure: {
        display: 'flex',
        height: '95%',
        overflow: 'hidden',
        background: '#F8F8F8'
    },
    figureLogo: {
        display: 'flex',
        height: 140,
        width: '100%',
        overflow: 'hidden',
        background: '#F8F8F8'
    },
    brandBanner: { display: 'flex', flexFlow: 'row wrap', justifyContent: 'center', textAlign: 'center' },
    brandBannerLabel: { width: '40%', left: '54%' },
    brandBannerSpecifications: { fontSize: 12 },
    textArea: {
        height: 140
    },
    labelStyler: {
        paddingTop: 9,
        fontWeight: 500,
        color: '#000'
    },
    orderingPageLabel: {
        padding: '9px 10px 9px 0px',
        fontWeight: 500,
        color: '#000'
    },
    restaurantsHeading: {
        borderBottom: "1px solid #dee2e6",
        display: 'flex'
    },
    sections: {
        paddingRight: 30,
        cursor: 'pointer'
    },
    active: {
        color: '#0288D1'
    },
    rowStyler: {
        marginTop: 20
    },
    saveButton: {
        float: 'right'
    },
    inputCheckbox: {
        marginLeft: '20px'
    },
    locationColor: {
        color: '#007bff'
    },
    alignRight: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    tableThStyle: {
        paddingLeft: 6,
        paddingRight: 6,
        paddingTop: 10,
        paddingBottom: 10
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    },
    // Simple Search Styles
    inputGroupAddon: {
        marginTop: '10px'
    },
    inputGroupSearch: {
        border: '1px solid lightgray'
    },
    inputSearch: {
        border: 0
    },
    simpleSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    // Advanced Search Styles
    advancedSearchIcon: {
        float: 'left'
    },
    searchButtonStyle: {
        width: '100%',
    },
    advancedSearchClearStyle: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    simpleSearchButton: {
        paddingRight: 0
    },
    paddingLeftRight: {
        paddingLeft: 5,
        paddingRight: 5
    },
    paddingRight: {
        paddingRight: 5
    },
    advancedSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    advancedSearchMainCol: {
        display: 'flex',
        flexDirection: 'row'
    },
    // Assign manager
    managerFieldGroups: {
    },
    managerDetails: {
        fontSize: '14px',
        color: '#000'
    },
    saveWarning: {
        color: '#dc3545',
        fontSize: '80%',
        float: 'right'
    },
    noBottomMargin: {
        marginBottom: 0
    },
    authorizationErrorMessageContainer: {
        textAlign: 'center',
        marginTop: 100
    },
    spaceBetween: {
        paddingLeft: 4
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    textOverflowHidden: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    alignInRow: {
        display: 'flex',
        flexDirection: 'row'
    },
    brandFields: {
        paddingLeft: 24
    },
    alignInColumn: {
        display: 'flex',
        flexDirection: 'column'
    },
    brandLogoLabel: { width: '70%', left: '57%' },
    specificationsContainer: { display: 'flex', flexFlow: 'row wrap', justifyContent: 'center' },
    specificationsText: { fontSize: 12, textAlign: 'center' },
    noPadding: {
        padding: 0
    },
    assignManagerBtn: {
        padding: '0px 0px 4px 10px'
    }
}


// WEBPACK FOOTER //
// ./src/components/brands/BrandScreen.js